import { render, staticRenderFns } from "./FBtitle.vue?vue&type=template&id=b59fb26a"
import script from "./FBtitle.vue?vue&type=script&lang=js"
export * from "./FBtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports